/**
 * Which open database editor an agent's db_editor event is for (#352). Every
 * open workspace stays mounted, each with its own active tab, so "the active
 * editor" is not one editor — an event must name its target, and each viewer
 * asks these before acting. Pure, so the routing is testable without mounting
 * `DatabaseViewer`.
 */

/**
 * The executed call (`papan:client-tool-request`): a request naming an editor
 * applies only in the viewer with that registry key. A request naming none (an
 * older agent bundle) keeps the old active-tab rule — `active` decides it.
 */
export function editorActionIsMine(detail: { editor?: { key?: string } }, registryKey: string, active = false): boolean {
  if (detail.editor) return detail.editor.key === registryKey
  return active
}

/**
 * The streamed SQL preview (`papan:editor-action-preview`): only in the
 * streaming session's workspace, and — when the turn's chip named a database —
 * only that file, active tab or not; else that workspace's active tab.
 */
export function streamPreviewIsMine(
  detail: { workspaceId?: unknown; fileId?: unknown },
  me: { workspaceId: string | null; fileId: string; active: boolean },
): boolean {
  if (typeof detail.workspaceId === 'string' && detail.workspaceId !== me.workspaceId) return false
  return typeof detail.fileId === 'string' ? detail.fileId === me.fileId : me.active
}
